import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AthHeader from "../components/header/AthHeader";
import * as aaUtil from "../utils/aaUtils";
import * as extUtil from "../utils/externalUtils";

import "./AthLayoutFlex.css";

import Api from '../../utils/api';

class AthLayoutFlex extends Component {

  orderStyle = {
    order: 2
  };

  componentDidMount() {
    aaUtil.mountAdobeScript();
    // aaUtil.initializeDigitalData();
    // console.log("Digital Data");
    // // aaUtil.mountDataLayer();
  }

  render() {
    const urlPath = this.props.match.path;
    return (
      <div className="container-fluid ath-container-fluid">
        <AthHeader location={urlPath} history={this.props.history} />

        <div
          id="content-container"
          className="container-full"
          style={this.orderStyle}
        >
          {this.props.children}
        </div>
        <div className="ath-steps__powered-section">
          Powered by{" "}
          <a target="_blank" href="/">
            <img
              alt="HelloAva logo"
              src="/images/ath/footer/powered-by-ha.svg"
            />
          </a>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { helloava } = state;
  const { isAuthenticated } = helloava.auth;
  return { isAuthenticated };
}

export default withRouter(connect(mapStateToProps)(AthLayoutFlex));



// WEBPACK FOOTER //
// ./src/ath/layout/AthLayoutFlex.js